export default __webpack_public_path__ + "static/media/markt.cf9de54f.jpg";